import React, { useState } from 'react';
import { ExternalLink, Copy } from 'lucide-react';

interface Prospect {
  id: string;
  prenom: string;
  nom: string;
  email: string;
  linkedin: string;
  site_url: string;
  token: string;
  page_vue: boolean;
  quiz_fait: boolean;
  score: number;
  rdv_pris: boolean;
  created_at: string;
  updated_at: string;
  metadata?: any;
  telephone?: string;
  poste?: string;
  notes?: string;
  source?: string;
}

interface TestLinkCardProps {
  prospect: Prospect;
}

const TestLinkCard: React.FC<TestLinkCardProps> = ({ prospect }) => {
  const [copied, setCopied] = useState(false);

  const testUrl = `${window.location.origin}/analyse/${prospect.token}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(testUrl);
      setCopied(true);
      // Affiche le message de confirmation pendant 2 secondes
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Erreur lors de la copie:', err);
    }
  };

  return (
    <div className="space-y-4">
      {/* Lien de test compact */}
      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg p-4 border border-indigo-200">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-medium text-indigo-900">Lien personnalisé</h3>
          <button
            onClick={copyToClipboard}
            className={`inline-flex items-center px-2 py-1 text-xs font-medium ${copied ? 'text-green-600' : 'text-indigo-600 hover:text-indigo-800'} transition-colors`}
            disabled={copied}
          >
            <Copy className={`w-3 h-3 mr-1 ${copied ? 'text-green-500' : ''}`} />
            {copied ? 'Copié !' : 'Copier'}
          </button>
        </div>
        
        <div className="text-xs text-indigo-700 mb-3 break-all bg-white/50 p-2 rounded border">
          {testUrl}
        </div>
        
        <a
          href={testUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md transition-colors"
        >
          <ExternalLink className="w-3 h-3 mr-1" />
          Ouvrir
        </a>
      </div>

      {/* Statut compact */}
      <div className="grid grid-cols-3 gap-2 text-xs">
        <div className={`text-center p-2 rounded ${prospect.page_vue ? 'bg-green-50 text-green-700' : 'bg-gray-50 text-gray-500'}`}>
          <div className={`w-2 h-2 rounded-full mx-auto mb-1 ${prospect.page_vue ? 'bg-green-500' : 'bg-gray-400'}`}></div>
          Page vue
        </div>
        <div className={`text-center p-2 rounded ${prospect.quiz_fait ? 'bg-green-50 text-green-700' : 'bg-gray-50 text-gray-500'}`}>
          <div className={`w-2 h-2 rounded-full mx-auto mb-1 ${prospect.quiz_fait ? 'bg-green-500' : 'bg-gray-400'}`}></div>
          Quiz terminé
        </div>
        <div className={`text-center p-2 rounded ${prospect.rdv_pris ? 'bg-green-50 text-green-700' : 'bg-gray-50 text-gray-500'}`}>
          <div className={`w-2 h-2 rounded-full mx-auto mb-1 ${prospect.rdv_pris ? 'bg-green-500' : 'bg-gray-400'}`}></div>
          RDV pris
        </div>
      </div>
    </div>
  );
};

export default TestLinkCard;